import { api } from "api";

/**
 * Account statements (كشف حساب) API client. Wraps the /api/statements
 * endpoints. v1 is vendor-only; the audience field is plumbed through so
 * the future delivery-statement phase plugs in without service changes.
 */

export const previewStatement = async (data) => {
    const response = await api.post("api/statements/preview", data);
    return response.data;
};

/**
 * The date span of everything a vendor still owes a statement for, with no
 * window imposed. Lets the send-statement modal open on the full outstanding
 * period instead of a fixed lookback that would silently skip older orders.
 *
 * @param {object} params - { audience, vendorId } — vendorId is User.id.
 * @returns {Promise<{ordersCount: number, earliestOrderDate: string|null, latestOrderDate: string|null}>}
 */
export const getStatementPendingRange = async (params) => {
    const response = await api.get("api/statements/pending-range", { params });
    return response.data;
};

export const createStatement = async (data) => {
    const response = await api.post("api/statements", data);
    return response.data;
};

export const listStatements = async (params) => {
    const response = await api.get("api/statements", { params });
    return response.data;
};

export const getStatement = async (id) => {
    const response = await api.get(`api/statements/${id}`);
    return response.data;
};

export const resendStatementWhatsapp = async (id) => {
    const response = await api.post(`api/statements/${id}/resend`);
    return response.data;
};

/**
 * Toggle a statement's payment status. Backed by
 * PATCH /api/statements/:id/payment. Admin-only on the server side.
 */
export const setStatementPayment = async (id, isPaid) => {
    const response = await api.patch(`api/statements/${id}/payment`, { isPaid });
    return response.data;
};
